import { publicEnv } from "@/config/env";
import AllotmentsList from "@/features/allotments/components/allotment-list";
import { HeroMarkdownSection } from "@/features/shared/components/hero-markdown-section-client";
import { HeroMarkdownSkeleton } from "@/features/shared/components/hero-markdown-skeleton";
import { NotFoundPage } from "@/features/shared/components/not-found-page";
import { useLng } from "@/hooks/use-lng";
import { appTitleHead } from "@/lib/app-document-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

export const Route = createFileRoute("/_app/allotments/")({
  head: () => appTitleHead("allotments"),
  component: AllotmentsPage
});

function AllotmentsPage() {
  const lng = useLng();

  if (publicEnv.USE_BOOKING === "false" || publicEnv.USE_ALLOTMENT === "false") {
    return <NotFoundPage />;
  }

  return (
    <div className="w-full">
      <Suspense fallback={<HeroMarkdownSkeleton />}>
        <HeroMarkdownSection lng={lng} section="allotments" />
      </Suspense>
      <AllotmentsList />
    </div>
  );
}
